import { render, staticRenderFns } from "./NaviBar.vue?vue&type=template&id=d518ef44&"
import script from "./NaviBar.vue?vue&type=script&lang=js&"
export * from "./NaviBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMenu: require('/officebalance/components/HeaderMenu.vue').default})
